import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

type Props = {
  variant: 'green' | 'yellow' | 'red' | 'blue' | 'gray';
  children?: ReactNode;
};

export const InfoBox = ({ children, variant }: Props) => {
  return (
    <div
      className={twJoin(
        'flex items-center p-4 text-sm rounded-lg',
        variant === 'green'
          ? 'text-green-800 bg-green-50 dark:bg-gray-800 dark:text-green-400'
          : variant === 'yellow'
          ? 'text-yellow-800 bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300'
          : variant === 'red'
          ? 'text-red-800 bg-red-50 dark:bg-gray-800 dark:text-red-400'
          : variant === 'gray'
          ? 'text-gray-800 bg-gray-50 dark:bg-gray-800 dark:text-gray-300'
          : 'text-blue-800 bg-blue-50 dark:bg-gray-800 dark:text-blue-400',
      )}
    >
      {children}
    </div>
  );
};
